export default __webpack_public_path__ + "static/media/stepper-check.82c98755.svg";